import React, { useState, useEffect, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function Product() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDados = useCallback(async () => {
    setLoading(true);
    const response = await api.get('/produtos');
    const data = response.data.map(i => ({
      ...i,
      cadencia: i.cadencia ? i.cadencia.name : 'Sem cadencia',
      statusFormat: i.status === '1' ? 'Ativo' : 'Inativo',
    }));
    setDados(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    getDados();
  }, [getDados]);

  /**
   * Funções
   */

  async function handlerEditar(number) {
    history.push(`/produto-edit/${number}`);
  }

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/produtos/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Produto ativado/desativado com sucesso');
            getDados();
          }
        });
      } else {
        const response = await api.delete(`/produtos/${number}`);

        if (response.data) {
          toast.success('Produto ativado/desativado com sucesso');
          getDados();
        }
      }
    } catch (error) {
      toast.error('Erro ao ativar/desativar produto');
    } finally {
      setLoading(false);
    }
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'cidade.name',
      label: 'Cidade',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'time.name',
      label: 'Time',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'incorporadora.name',
      label: 'Incorporadora',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'cadencia',
      label: 'Cadência',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <Card>
          <Menus>
            <NewButton to="/produto-create">
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
          </Menus>
          <Table
            title="Integrações"
            data={dados}
            columns={columns}
            ds={handlerStatus}
            ed={handlerEditar}
            messages="Você deseja ativar/desativar o produto ?"
            st
          />
        </Card>
      </Container>
    </>
  );
}
